import {
  Waves,
  Wifi,
  Armchair,
  GlassWater,
  Flame,
  Anchor,
  Bed,
  Zap,
  Droplet,
  Table,
  Home,
  Car,
  type LucideIcon,
} from "lucide-react";
import type { ComponentType } from "react";

export type AmenityIcon = LucideIcon | ComponentType<{ className?: string }>;
export interface Amenity { id: string; label: string; Icon: AmenityIcon; }

export const AMENITY_CATALOG: Record<string, Amenity> = {
  thatched_roof:       { id: "thatched_roof",       label: "Thatched Roof",             Icon: Home },
  parking_two_cars:    { id: "parking_two_cars",    label: "Parking for Two Cars",      Icon: Car },
  wifi:                { id: "wifi",                label: "Wi-Fi",                     Icon: Wifi },
  comfortable_seating: { id: "comfortable_seating", label: "Comfortable Seating",       Icon: Armchair },
  bar_top:             { id: "bar_top",             label: "Bar Top",                   Icon: GlassWater },
  picnic_table:        { id: "picnic_table",        label: "Picnic Table",              Icon: Table },
  barbecue_grill:      { id: "barbecue_grill",      label: "Barbecue Grill",            Icon: Flame },
  private_dock:        { id: "private_dock",        label: "Private Dock",              Icon: Anchor },
  water_entry_ladder:  { id: "water_entry_ladder",  label: "Water Entry Ladder",        Icon: Waves },
  hammock:             { id: "hammock",             label: "Hammock",                   Icon: Bed },
  electricity:         { id: "electricity",         label: "Electricity",               Icon: Zap },
  water:               { id: "water",               label: "Water",                     Icon: Droplet },
};

export interface AccommodationOption { id: string; label: string; amenityIds: string[]; }

// Son's Island accommodation types — popup amenity list
export const ACCOMMODATION_OPTIONS: AccommodationOption[] = [
  { id: "island_cabana",   label: "Island Cabanas (A–C)",  amenityIds: ["parking_two_cars","thatched_roof","wifi","comfortable_seating","bar_top","picnic_table","barbecue_grill","private_dock","water_entry_ladder","hammock","electricity","water"] },
  { id: "key_cabana",      label: "Key Cabanas",           amenityIds: ["parking_two_cars","thatched_roof","wifi","comfortable_seating","bar_top","picnic_table","barbecue_grill","private_dock","water_entry_ladder","hammock","electricity","water"] },
  { id: "glamping_cabin",  label: "Glamping",              amenityIds: [] },
];

const MAP = Object.fromEntries(ACCOMMODATION_OPTIONS.map((o) => [o.id, o]));

export function parseAccommodationIds(csv: string): string[] {
  return csv.split(",").map((s) => s.trim()).filter((s) => s.length > 0 && MAP[s]);
}

export function amenitiesForAccommodations(accIds: string[]): Amenity[] {
  const seen = new Set<string>(); const ordered: string[] = [];
  for (const id of accIds) {
    const acc = MAP[id]; if (!acc) continue;
    for (const aid of acc.amenityIds) if (!seen.has(aid)) { seen.add(aid); ordered.push(aid); }
  }
  return ordered.map((id) => AMENITY_CATALOG[id]).filter(Boolean);
}
